"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Conversion = void 0;
var _requester = require("../requester"),
  _types = require("./types"),
  _types2 = require("../types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var Conversion = /*#__PURE__*/function () {
  function Conversion(a) {
    _classCallCheck(this, Conversion);
    var b = a.goalId,
      _a$revenue = a.revenue,
      c = _a$revenue === void 0 ? 0 : _a$revenue,
      _a$negative = a.negative,
      d = _a$negative === void 0 ? !1 : _a$negative;
    _defineProperty(this, "status", void 0), _defineProperty(this, "goalId", void 0), _defineProperty(this, "revenue", void 0), _defineProperty(this, "negative", void 0), _defineProperty(this, "id", void 0), _defineProperty(this, "nonce", void 0), this.goalId = b, this.revenue = c, this.negative = d, this.status = _types2.TrackingStatus.Unsent, this.id = Math.floor(1e6 * Math.random());
  }
  return _createClass(Conversion, [{
    key: "_id",
    set: function set(a) {
      this.id = a;
    }
  }, {
    key: "_nonce",
    set: function set(a) {
      this.nonce = a;
    }
  }, {
    key: "url",
    get: function get() {
      return _requester.UrlEventType.Conversion + _requester.UrlParameter.GoalId + (this.goalId + "") + _requester.UrlParameter.Revenue + (this.revenue + "") + _requester.UrlParameter.Negative + (this.negative + "");
    }
  }, {
    key: "data",
    get: function get() {
      return {
        goalId: this.goalId,
        nonce: this.nonce,
        revenue: this.revenue,
        negative: this.negative,
        type: _types.KameleoonData.Conversion,
        status: this.status,
        id: this.id
      };
    }
  }], [{
    key: "_fromRaw",
    value: function _fromRaw(a) {
      var b = a.goalId,
        c = a.revenue,
        d = a.negative,
        e = a.status,
        f = a.id,
        g = a.nonce,
        h = new Conversion({
          goalId: b,
          revenue: c,
          negative: d
        });
      return h._id = f, h.status = e, g && (h._nonce = g), h;
    }
  }, {
    key: "_listFromVisit",
    value: function _listFromVisit(a) {
      var b, c;
      var d = [];
      if (!(null !== (b = a.conversionEvents) && void 0 !== b && b.length)) return [];
      if (null !== (c = a.conversionEvents) && void 0 !== c && c.length) {
        var _iterator = _createForOfIteratorHelper(a.conversionEvents),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _b = _step.value;
            var _b$data = _b.data,
              _a = _b$data.goalId,
              _c = _b$data.revenue,
              e = _b$data.negative,
              f = new Conversion({
                goalId: _a,
                revenue: _c,
                negative: e
              });
            f.status = _types2.TrackingStatus.Sent, d.push(f);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return d;
    }
  }, {
    key: "_updateFromVisit",
    value: function _updateFromVisit(a, b) {
      var c;
      if (null !== (c = a.conversionEvents) && void 0 !== c && c.length) {
        var _iterator2 = _createForOfIteratorHelper(a.conversionEvents),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _c2 = _step2.value;
            var _a2 = _c2.data.goalId;
            if (!b.has(_a2)) {
              var _c3 = new Conversion({
                goalId: _a2
              });
              _c3.status = _types2.TrackingStatus.Sent, b.set(_a2, _c3);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }]);
}();
exports.Conversion = Conversion;